import React from 'react'
import styles from './styles.css'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import getEnv from 'App/Root/getEnv'

const isMobile = () => window.innerWidth < 768

const logo = isMobile() ? '/new-logo.svg' : '/new-isologo.svg'

const Logo = ({ to = '/accounts' }) => {
  return (
    <div className={styles.container}>
      <Link to={to}>
        <img src={logo} alt="orion x logo" height={30} width={198} />
      </Link>
      {getEnv() !== 'prod' && <span> {getEnv()}</span>}
    </div>
  )
}

Logo.propTypes = {
  to: PropTypes.string,
}

export default Logo
